import React, { useCallback } from 'react'
import { observer } from 'mobx-react'
import { classNames, toPrice } from '@dt/fe-utils'
import { ProductImage, Stepper } from 'components'
import CashierController from 'controllers/cashierController'
import { cartMobx } from 'restaurant'

// interface
interface IProps {
  product: IViewProduct;
  onClick?: (product: IViewProduct) => void;
  count?: number;
  lazy?: boolean;
  backgroundMode?: 'light' | 'dark';
  imgLoaded?: boolean;
  decorate?: TMealCommonDecorates;
}

const ProductItem: React.FC<IProps> = ({ product, count, lazy = false, imgLoaded = false, decorate, onClick }) => {
  let { name, price, actualPrice, offPrice, isCanTogo } = product || {}
  const formatOriginPrice = toPrice(price)
  const formatMarketPrice = toPrice(actualPrice)

  const handleChangeCnt = useCallback((isAdd: boolean, event: React.MouseEvent) => {
    event.stopPropagation()
    CashierController.handleProductToCart({
      type: isAdd ? 'add' : 'minus',
      product
    })
  }, [count])

  return (
    <div
      className={classNames(
        'bought-product-item',
        `${decorate?.imagePosition || 'left'}-list`,
        {
          'has-pic': !!product.pic
        }
      )}
      onClick={() => onClick ? onClick(product) : CashierController.showProductDetail(product)}
    >
      <div className='product-info'>
        <h3 style={{ fontSize: `${decorate?.fontSetting?.name?.fontSize - 2 || 14}px`, fontWeight: decorate?.fontSetting?.name?.fontWeight ? 700 : 500 }}>{name}</h3>
        <span>{offPrice ? formatMarketPrice : formatOriginPrice}</span>
        <div className='product-extra'>
          <Stepper cnt={count} onChange={handleChangeCnt} hideMinus={count === 0} disabled={cartMobx.info.eatType !== 'dinein' && !isCanTogo} />
        </div>
      </div>
      {
        !!product.pic && (
          <ProductImage
            imgSrc={(imgLoaded || !lazy) ? product.pic : ''}
            width={40}
            height={40}
          />
        )
      }
    </div>
  )
}
export default observer(ProductItem)
